module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AbilityView.js"));
	}, "AbilityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AbilityView!./src/pages/Learn/My/Ability/AbilityView.js
// module id = 2216
// module chunks = 367